import { ConfinusUI__Forms__CheckboxControllerIdentifier } from "controllers/identifiers";
import BaseController from "confinus_ui/base_controller";
import CheckboxController from "confinus_ui/forms/checkbox_controller";

export default class DataTableHeaderRowController extends BaseController {
  public static outlets = [ConfinusUI__Forms__CheckboxControllerIdentifier];
  declare private readonly confinusUiFormsCheckboxOutlet: CheckboxController;
  private get checkboxController() {
    return this.confinusUiFormsCheckboxOutlet;
  }

  private checkboxChangeListeners: Set<(value: boolean) => void> = new Set();

  public disconnect() {
    this.checkboxChangeListeners.clear();
    super.disconnect();
  }

  public get checked(): boolean {
    return !!this.checkboxController?.checked;
  }

  public set checked(state: boolean) {
    if (this.checkboxController) {
      this.checkboxController.checked = state;
    }
  }

  public get indeterminate(): boolean {
    return !!this.checkboxController?.indeterminate;
  }

  public set indeterminate(state: boolean) {
    if (this.checkboxController) {
      this.checkboxController.indeterminate = state;
    }
  }

  public handleCheckboxChange(evt: Event) {
    const target = evt.target as HTMLInputElement;
    this.checkboxChangeListeners.forEach((listener) => {
      listener(target.checked);
    });
  }

  public onCheckboxChange(cb: (checked: boolean) => void) {
    this.checkboxChangeListeners.add(cb);
    return () => this.checkboxChangeListeners.delete(cb);
  }
}
